// 封装 axios
import axios from 'axios';
const pending = []; // 存储每个请求的 axios 标识(tag)和取消函数(cancel)
const CancelToken = axios.CancelToken;
const removePending = config => {
  for (let p in pending) {
    if (pending[p].tag === config.url + JSON.stringify(config.params)) {
      // pending[p].cancel(); // 执行取消
      // pending.splice(p, 1);
    }
  }
};

// 使用 create 方法创建 axios 实例
const Service = axios.create({
  // baseURL: '/api',
  headers: {
    post: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  }
});
Service.defaults.timeout = 8 * 1000;

// 添加请求拦截器
Service.interceptors.request.use(config => {
  removePending(config); // 取消请求
  config.cancelToken = new CancelToken(c => {
    pending.push({
      tag: config.url + JSON.stringify(config.params),
      cancel: c
    });
  });
  return config;
});

// 添加响应拦截器
Service.interceptors.response.use(response => {
  removePending(response.config); // 取消响应
  return response.data;
}, error => {
  return Promise.resolve(error.response.status);
});
export default {
  get({
    url,
    params,
    headers
  }) {
    let config = {};
    if (params) {
      config.params = params;
    }
    if (headers) {
      config.headers = headers;
    }
    return Service.get(url, config);
  },
  post({
    url,
    params,
    config = {}
  }) {
    return Service.post(url, params, config);
  },
  getBlob({
    url,
    params,
    headers
  }) {
    let config = {};
    if (params) {
      config.params = params;
      config.responseType = 'arraybuffer'
    }
    if (headers) {
      config.headers = headers;
    }
    return Service.get(url, config);
  },
};